module.exports = __webpack_public_path__ + "static/media/fontello.45befed7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/font/fontello.eot?8095705
// module id = 165
// module chunks = 0